import { CaseStudy } from './types';
import { realtypassCaseStudy } from './data/realtypass';
import { scholasticCaseStudy } from './data/scholastic';
import { stylematchCaseStudy } from './data/stylematch';
import { smartcertsCaseStudy } from './data/smartcerts';

export const caseStudiesData: CaseStudy[] = [
  realtypassCaseStudy,
  scholasticCaseStudy,
  stylematchCaseStudy,
  smartcertsCaseStudy,
];
